import Link from '@atoms/Link'
import MaskedIcon from '@icons/Masked'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

type ArticleMaskProps = {
  redirect: string
}
const ArticleMask = ({ redirect }: ArticleMaskProps) => {
  const { t } = useTranslation()

  return (
    <>
      <div className={style.articleMask}>
        <div className={style.limit}>
          <MaskedIcon />
          <br data-only="sp" />
          <span dangerouslySetInnerHTML={{ __html: t('mypage.maskLimit') }} />
        </div>
        <div className={style.buttonContainer}>
          <Link to={`/signup?redirect=${redirect}`}>
            {t('mypage.signupFree')}
          </Link>
          <Link to={`/signin?redirect=${redirect}`}>
            {t('mypage.haveAccout')}
          </Link>
        </div>
        <div className={style.benefit}>
          <div className={style.enable}>{t('mypage.enablePoints')}</div>
          <ul>
            <li>
              <CheckIcon />
              <span
                dangerouslySetInnerHTML={{ __html: t('mypage.enablePoint1') }}
              />
            </li>
            <li>
              <CheckIcon />
              <span
                dangerouslySetInnerHTML={{ __html: t('mypage.enablePoint2') }}
              />
            </li>
            <li>
              <CheckIcon />
              <span
                dangerouslySetInnerHTML={{ __html: t('mypage.enablePoint3') }}
              />
            </li>
            <li>
              <CheckIcon />
              <span
                dangerouslySetInnerHTML={{ __html: t('mypage.enablePoint4') }}
              />
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

const CheckIcon = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path
      d="M10.5 1.875C6.01992 1.875 2.375 5.51992 2.375 10C2.375 14.4801 6.01992 18.125 10.5 18.125C14.9801 18.125 18.625 14.4801 18.625 10C18.625 5.51992 14.9801 1.875 10.5 1.875ZM9.01562 14.0773L5.86719 10.5785L6.79648 9.74219L8.98398 12.1727L14.1719 5.99453L15.1305 6.79688L9.01562 14.0773Z"
      fill="currentColor"
    />
  </svg>
)

export default ArticleMask
